var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup160(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0.777832C47.73 0.777832 61.25 13.8965 61.25 30.0278C61.25 46.1592 47.73 59.2778 31 59.2778C14.27 59.2778 0.75 46.1592 0.75 30.0278C0.75 13.8965 14.27 0.777832 31 0.777832Z",
    stroke: "#006D77",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2681 15.0278V25.2064L21.5895 28.4207C21.5895 28.4207 21.5895 44.4921 21.5895 47.1707C21.5895 49.8493 26.0181 49.8493 26.0181 47.1707C26.0181 44.4921 26.0181 28.4207 26.0181 28.4207L28.7859 25.2064V15.0278M21.5895 15.0278V25.7421M24.9109 15.0278V25.7421M37.0895 47.1707C37.0895 50.9207 41.5181 50.385 41.5181 47.1707V28.4207C45.3931 25.2064 43.7324 15.0278 38.7502 15.0278C33.7681 15.0278 32.1074 26.2778 37.0895 28.4207V47.1707Z",
    stroke: "#006D77",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4999 45.2224C59.209 32.0394 47.2462 10.6726 30.9999 10.9694C25.9683 11.1421 23.8292 11.9143 19.4999 14.7752M17.4999 16.2025C9.50002 24.29 8.99985 37.1349 20.4999 46.1739M27 48.5526C31 49.0283 32.2101 49.1827 36 48.0768",
    stroke: "#006D77",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup160);
export default __webpack_public_path__ + "static/media/Group 160.081153b0e4983d9486d9691e781dcb1d.svg";
export { ForwardRef as ReactComponent };